function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';
import ReactDOM from 'react-dom';
import { WDHComponent } from '../../../../wdh-foundation/wdh';
import AccordionSpot from './react-accordion-spot';
/**
 * @memberOf module:wdh-accordion-spot
 */

var WDHAccordionSpot = /*#__PURE__*/function (_WDHComponent) {
  _inherits(WDHAccordionSpot, _WDHComponent);

  var _super = _createSuper(WDHAccordionSpot);

  /**
   * @param {String} className - The unique css selector that triggers the component
   * @constructor
   * @augments WDHComponent
   * @inheritDoc
   */
  function WDHAccordionSpot() {
    var _this;

    var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'accordion-spot';

    _classCallCheck(this, WDHAccordionSpot);

    _this = _super.call(this, className);
    /**
     * The react component to render
     * @property {React.Component} [reactApp=AccordionSpot]
     */

    _this.reactApp = AccordionSpot;
    /**
     * Resolves the layout method of the component. If the function returns false the mobile version should be rendered.
     * If the function returns true the desktop version should be rendered.
     * @property {function(): boolean}
     */

    _this.resolveDesktop = _this.isDesktop;
    /**
     * Overrides the settings data loaded from Sitecore
     * @property {Object} settings
     * @property {string} settings.mobileBackgroundImage
     * @property {string} settings.desktopBackgroundImage
     * @property {string} settings.expandAllLabel
     * @property {string} settings.shrinkAllLabel
     * @property {boolean} settings.allowMultipleItemsExpanded
     * @property {number} settings.expandItemOnLoad
     * @property {boolean} settings.expandAllOnLoad
     * @property {boolean} settings.microdataenabled
     */

    _this.overrideSettings = {};
    return _this;
  }

  _createClass(WDHAccordionSpot, [{
    key: "isDesktop",
    value: function isDesktop() {
      return window.matchMedia('(min-width: 992px)').matches;
    }
  }, {
    key: "init",
    value: function init(component) {
      var settings = this.getSettingsFromComponent(component);
      ReactDOM.render( /*#__PURE__*/React.createElement(this.reactApp, {
        settings: settings,
        resolveDesktop: this.resolveDesktop
      }), component.querySelector('.component-content'));
    }
    /**
     * Get the rendered settings for the component instance given by *component*
     * @param component
     * @private
     */

  }, {
    key: "getSettingsFromComponent",
    value: function getSettingsFromComponent(component) {
      var settingsElement = component.querySelector('script[type="application/json"]');
      var settings = {};

      try {
        settings = JSON.parse(settingsElement.textContent);
      } catch (e) {
        settings.error = "".concat(e.name, " - ").concat(e.message);
      }

      settings = Object.assign(settings, this.overrideSettings);
      return settings;
    }
  }]);

  return WDHAccordionSpot;
}(WDHComponent);

export default WDHAccordionSpot;